/**
 * Shadows + the z-index ladder. The `Z` layers fold in HUD_Z_INDEX 1:1
 * (background/hud/window/tooltip/modal/debug/launcher) and add
 * `gameplayWindow` (the panels' de-facto zIndex 500) + `toast`.
 */
export const SHADOW = {
  sm: '0 2px 8px rgba(0, 0, 0, 0.4)',
  md: '0 8px 18px rgba(0, 0, 0, 0.35)',
  lg: '0 12px 28px rgba(0, 0, 0, 0.35)',
  glow: '0 0 12px rgba(255, 215, 0, 0.4)',
} as const;

export const Z = {
  background: 0,
  hud: 100,
  actionbar: 150, // Hotbar sits above chat/HUD panels to guarantee input priority
  npcWindow: 150, // NPC dialogue above HUD, below managed windows.
  window: 200,
  tooltip: 300,
  modal: 400,
  gameplayWindow: 500,
  debug: 1000,
  launcher: 9999,
  toast: 99999,
} as const;

export type ShadowKey = keyof typeof SHADOW;
export type ZLayer = keyof typeof Z;
